import { postData } from './fetch';

const changeZharcoins = async ({
    errorText,
    submitButton,
    value,
}) => {
    [].forEach.call(errorText || [], (text) => {
        text.classList.add('hidden');
    });
    submitButton && submitButton.classList.add('disabled');

    const responseZharcoins = await postData(
      '/orders/use-coins',
      JSON.stringify({
        wallets: value
      }),
      {
          contentType: 'application/json',
          withoutURLSearchParams: true,
      },
    );

    if (errorText && responseZharcoins && responseZharcoins.statusCode !== 200) {
        [].forEach.call(errorText, (text) => {
            text.classList.remove('hidden');
        });
    }

    submitButton && submitButton.classList.remove('disabled');
};

export default changeZharcoins;
